export default "__VITE_ASSET__BmzE9ynH__"